<svg-icon class="animate-spin" key="optimo-spinner-64" [size]="iconSize()" />
@if (loadingText(); as loadingText) {
  <span class="text-small font-bold">
    {{ loadingText }}
  </span>
}
